<template>
  <div class="ocean-log-page">
    <div class="page-title">
      <div>
        <h2>巨量操作日志</h2>
        <p>查询并采集巨量营销后台的官方操作记录</p>
      </div>
      <el-button
          size="small"
          type="primary"
          icon="el-icon-refresh"
          :loading="syncLoading"
          @click="syncLogs"
      >
        同步当前条件
      </el-button>
    </div>

    <div class="filter-bar">
      <span class="filter-label">日期</span>
      <el-date-picker
          v-model="dateRange"
          size="small"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 260px"
          @change="search"
      />
      <span class="filter-label">账号ID</span>
      <el-input
          v-model="filters.advertiserId"
          size="small"
          clearable
          placeholder="请输入账号ID"
          style="width: 160px"
          @keyup.enter.native="search"
      />
      <span class="filter-label">对象ID</span>
      <el-input
          v-model="filters.objectId"
          size="small"
          clearable
          placeholder="计划/广告/创意ID"
          style="width: 170px"
          @keyup.enter.native="search"
      />
      <span class="filter-label">对象类型</span>
      <el-select
          v-model="filters.objectType"
          size="small"
          clearable
          filterable
          placeholder="全部"
          style="width: 140px"
          @change="search"
      >
        <el-option
            v-for="item in objectTypeOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
        />
      </el-select>
      <span class="filter-label">关键词</span>
      <el-input
          v-model="filters.keyword"
          size="small"
          clearable
          placeholder="名称、内容、操作人、请求ID"
          style="width: 240px"
          @keyup.enter.native="search"
      />
      <el-button size="small" type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button size="small" icon="el-icon-refresh-left" @click="reset">重置</el-button>
    </div>

    <el-row :gutter="10" class="summary-row">
      <el-col :span="8">
        <div class="summary-card">
          <div class="summary-label">匹配行数</div>
          <div class="summary-value">{{ formatNumber(total) }}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="summary-card">
          <div class="summary-label">最近操作时间</div>
          <div class="summary-value small">{{ formatTime(summary.latest_operation_time) }}</div>
        </div>
      </el-col>
      <el-col :span="8">
        <div class="summary-card">
          <div class="summary-label">最近采集时间</div>
          <div class="summary-value small">{{ formatTime(summary.latest_fetched_at) }}</div>
        </div>
      </el-col>
    </el-row>

    <el-table
        v-loading="loading"
        :data="rows"
        border
        size="small"
        height="calc(100vh - 310px)"
    >
      <el-table-column prop="create_time" label="操作时间" width="170" :formatter="timeCell" fixed />
      <el-table-column prop="advertiser_id" label="账号ID" width="150" />
      <el-table-column prop="object_type" label="操作对象类型" width="130" show-overflow-tooltip />
      <el-table-column prop="object_id" label="操作对象ID" width="160" />
      <el-table-column prop="object_name" label="操作对象名称" min-width="260" show-overflow-tooltip />
      <el-table-column prop="content_title" label="操作内容" min-width="220" show-overflow-tooltip />
      <el-table-column prop="content_log" label="操作前后内容" min-width="320" show-overflow-tooltip />
      <el-table-column prop="operator" label="操作人" width="180" show-overflow-tooltip />
      <el-table-column prop="opt_ip" label="操作IP" width="130" show-overflow-tooltip />
      <el-table-column prop="request_id" label="请求日志ID" width="190" show-overflow-tooltip />
      <el-table-column prop="fetched_at" label="采集时间" width="170" :formatter="fetchedTimeCell" />
    </el-table>

    <div class="pager">
      <span>共 {{ formatNumber(total) }} 条</span>
      <el-pagination
          background
          layout="sizes, prev, pager, next, jumper"
          :current-page="page"
          :page-size="pageSize"
          :page-sizes="[30, 50, 100, 200]"
          :total="total"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OceanEngineOperationLogs',
  data() {
    const today = this.todayDate()
    return {
      loading: false,
      syncLoading: false,
      rows: [],
      summary: {},
      total: 0,
      page: 1,
      pageSize: Number(localStorage.getItem('oceanEngineOperationLogPageSize') || 50),
      dateRange: [today, today],
      filters: {
        advertiserId: '',
        objectId: '',
        objectType: '',
        keyword: ''
      },
      objectTypeOptions: [
        { label: '项目', value: '项目' },
        { label: '广告', value: '广告' },
        { label: '创意', value: '创意' },
        { label: '计划', value: '计划' },
        { label: '账户', value: '账户' },
        { label: '素材', value: '素材' },
        { label: '广告组', value: '广告组' },
        { label: '其他', value: '其他' }
      ]
    }
  },
  mounted() {
    this.loadLogs()
  },
  methods: {
    async loadLogs() {
      this.loading = true
      try {
        const response = await this.$axios.get('/oceanengine/operation-logs', {
          params: Object.assign({}, this.queryParams(), {
            page: this.page,
            pageSize: this.pageSize
          })
        })
        if (!response.data || !response.data.success) {
          this.$message.error((response.data && response.data.msg) || '查询失败')
          return
        }
        const data = response.data.data || {}
        this.rows = data.list || []
        this.total = Number(data.total || 0)
        this.summary = data.summary || {}
      } finally {
        this.loading = false
      }
    },
    async syncLogs() {
      if (!this.filters.advertiserId) {
        try {
          await this.$confirm('未填写账号ID时，会按当天有消耗且启用的账号同步，可能耗时较长。是否继续？', '同步确认', {
            confirmButtonText: '继续',
            cancelButtonText: '取消',
            type: 'warning'
          })
        } catch (e) {
          return
        }
      }
      this.syncLoading = true
      try {
        const response = await this.$axios.post('/oceanengine/operation-logs/sync', this.queryParams())
        if (!response.data || !response.data.success) {
          this.$message.error((response.data && response.data.msg) || '同步失败')
          return
        }
        const data = response.data.data || {}
        this.$message.success(`同步完成：账号 ${data.accountCount || 0} 个，写入 ${data.savedLogs || 0} 条`)
        await this.loadLogs()
      } finally {
        this.syncLoading = false
      }
    },
    search() {
      this.page = 1
      this.loadLogs()
    },
    reset() {
      const today = this.todayDate()
      this.dateRange = [today, today]
      this.filters = {
        advertiserId: '',
        objectId: '',
        objectType: '',
        keyword: ''
      }
      this.search()
    },
    queryParams() {
      const range = Array.isArray(this.dateRange) ? this.dateRange : []
      return {
        startDate: range[0] || '',
        endDate: range[1] || '',
        advertiserId: this.filters.advertiserId,
        objectId: this.filters.objectId,
        objectType: this.filters.objectType,
        keyword: this.filters.keyword
      }
    },
    handlePageChange(page) {
      this.page = page
      this.loadLogs()
    },
    handleSizeChange(size) {
      this.pageSize = size
      localStorage.setItem('oceanEngineOperationLogPageSize', String(size))
      this.page = 1
      this.loadLogs()
    },
    todayDate() {
      const now = new Date()
      const y = now.getFullYear()
      const m = String(now.getMonth() + 1).padStart(2, '0')
      const d = String(now.getDate()).padStart(2, '0')
      return `${y}-${m}-${d}`
    },
    formatTime(value) {
      if (!value) return '-'
      const raw = String(value).trim()
      if (/T.*(?:Z|[+-]\d{2}:?\d{2})$/.test(raw)) {
        const date = new Date(raw)
        if (!Number.isNaN(date.getTime())) {
          const y = date.getFullYear()
          const m = String(date.getMonth() + 1).padStart(2, '0')
          const d = String(date.getDate()).padStart(2, '0')
          const h = String(date.getHours()).padStart(2, '0')
          const mi = String(date.getMinutes()).padStart(2, '0')
          const s = String(date.getSeconds()).padStart(2, '0')
          return `${y}-${m}-${d} ${h}:${mi}:${s}`
        }
      }
      const text = raw.replace('T', ' ')
      return text.length >= 19 ? text.slice(0, 19) : text
    },
    timeCell(row) {
      return this.formatTime(row.create_time)
    },
    fetchedTimeCell(row) {
      return this.formatTime(row.fetched_at)
    },
    formatNumber(value) {
      const number = Number(value || 0)
      if (!Number.isFinite(number)) return '-'
      return number.toLocaleString()
    }
  }
}
</script>

<style scoped>
.ocean-log-page {
  padding: 16px;
  background: #f3f6fb;
  min-height: 100%;
  color: #1f2937;
}

.page-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}

.page-title h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #111827;
}

.page-title p {
  margin: 6px 0 0;
  color: #6b7280;
  font-size: 12px;
}

.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.filter-label {
  color: #374151;
  font-size: 13px;
}

.summary-row {
  margin-bottom: 10px;
}

.summary-card {
  padding: 12px 14px;
  border: 1px solid #e5e7eb;
  background: #fff;
}

.summary-label {
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 6px;
}

.summary-value {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  min-height: 24px;
}

.summary-value.small {
  font-size: 14px;
  font-weight: 500;
}

.pager {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 0 0;
  color: #374151;
  font-size: 13px;
}
</style>
